export default __webpack_public_path__ + "static/media/coverImg.393346b5.png";